import {
  GETVIEWCUSTOMERBANKDETAILS_SUCCESS,
  GETVIEWCUSTOMERBANKDETAILS_FAILED,
  RESET_GETVIEWCUSTOMERBANKDETAILS,
  LOADING_GETVIEWCUSTOMERBANKDETAILS,
  NETWORK_ERROR_GETVIEWCUSTOMERBANKDETAILS,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetViewCustomerBankDetails = () => {
  return { type: RESET_GETVIEWCUSTOMERBANKDETAILS };
};

const GetViewCustomersBankdetailsList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETVIEWCUSTOMERBANKDETAILS });
    await partnerServices
      .post("getViewCustomerBankDetails", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(getViewCustomerBankdetailssuccess(res.data));
            break;
          default:
            dispatch(getViewCustomerBankdetailsFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETVIEWCUSTOMERBANKDETAILS,
          payload: err,
        });
      });
  };
function getViewCustomerBankdetailssuccess(data) {
  return {
    type: GETVIEWCUSTOMERBANKDETAILS_SUCCESS,
    payload: data,
  };
}
function getViewCustomerBankdetailsFailed(data) {
  return {
    type: GETVIEWCUSTOMERBANKDETAILS_FAILED,
    payload: data,
  };
}

export {
  resetGetViewCustomerBankDetails,
  GetViewCustomersBankdetailsList,
};
